import type { Choice, FaqItem, OfferItem } from '../types/offer'

export const IMAGES = {
  bundle: 'https://cdn.magicpatterns.com/uploads/9a1T2NJRAjbbdjeGvNtTSi/Bundle.png',
  treasuryBook: 'https://cdn.magicpatterns.com/uploads/jEuv2GjKV7eL9T9bKtmUvq/Producto_P.png',
  amigurumi: 'https://cdn.magicpatterns.com/uploads/52zRRBLN4823r2hkyqqfdd/bono-1.png',
  etsySeo: 'https://cdn.magicpatterns.com/uploads/f3vX99R43nQgWzaFxPK5sW/Bono-2.png',
  calculator: 'https://cdn.magicpatterns.com/uploads/hXoqysxhNF7M895SnbwT9v/Bono-3.png',
  viralHooks: 'https://cdn.magicpatterns.com/uploads/gPQQk2DRrwNTwXmVuuweH4/Bono-4.png',
  brandingKit: 'https://cdn.magicpatterns.com/uploads/cbKE2YQgwakTKtwPgzMx6P/Bono-5.png'
} as const

export const PRICE = {
  today: 27,
  totalValue: 616,
  savings: 589,
  singlePattern: 10
} as const

export const COUNTDOWN_SECONDS = 9 * 60 + 42

export const CHECKOUT = {
  url: 'https://rutinasimple.com//cart/53003685855513:1',
  variantId: '53003685855513',
  productName: 'The Ultimate Crochet Treasury 2026',
  value: 27,
  currency: 'USD'
} as const

export const offerItems: OfferItem[] = [
  {
    id: 'master-vault',
    kicker: 'The Main Vault',
    title: '1,000+ Viral Pattern Master-Vault',
    blurb: 'Every trending design in one library — including the "Chicken Bag" that broke TikTok.',
    value: 197,
    icon: 'vault',
    image: IMAGES.treasuryBook,
    imageAlt: 'The Ultimate Crochet Treasury hardcover book on a wooden table'
  },
  {
    id: 'amigurumi',
    kicker: 'Bonus 1',
    title: '500+ Amigurumi Secret Vault',
    blurb: 'The plush little characters that sell out at every craft fair, ready to hook tonight.',
    value: 97,
    icon: 'amigurumi',
    image: IMAGES.amigurumi,
    imageAlt: 'Tablet showing a gallery of amigurumi crochet patterns'
  },
  {
    id: 'etsy-seo',
    kicker: 'Bonus 2',
    title: 'Etsy SEO Secrets 2026',
    blurb: 'Rank #1 or don\u2019t sell at all. The exact keyword system buyers search for.',
    value: 67,
    icon: 'search',
    image: IMAGES.etsySeo,
    imageAlt: 'Etsy SEO Secrets 2026 workbook next to a laptop showing a seller dashboard'
  },
  {
    id: 'calculator',
    kicker: 'Bonus 3',
    title: 'Price for Profit Calculator',
    blurb: 'Stop working for free. Plug in yarn, hours and overhead — get a price that pays you.',
    value: 47,
    icon: 'calculator',
    image: IMAGES.calculator,
    imageAlt: 'Price for Profit pricing worksheet on a clipboard'
  },
  {
    id: 'viral-hooks',
    kicker: 'Bonus 4',
    title: '50 Viral Reels / TikTok Hooks',
    blurb: 'Your free traffic generator. Copy the hook, film the stitch, watch the orders land.',
    value: 37,
    icon: 'video',
    image: IMAGES.viralHooks,
    imageAlt: 'Phone on a tripod displaying a list of viral content hooks for makers'
  },
  {
    id: 'branding-kit',
    kicker: 'Bonus 5',
    title: 'The Maker\u2019s Branding Kit',
    blurb: 'Care cards, hang tags and thank-you notes that make $20 pieces feel like $60.',
    value: 47,
    icon: 'tag',
    image: IMAGES.brandingKit,
    imageAlt: 'Handmade hang tags, care cards and thank you cards on linen'
  },
  {
    id: 'license',
    kicker: 'Bonus 6',
    title: 'Full Commercial License',
    blurb: 'The right to get rich. You make it, you sell it, you keep every dollar.',
    value: 97,
    icon: 'license'
  },
  {
    id: 'roadmap',
    kicker: 'Bonus 7',
    title: '30-Day "Hobby to Pro" Roadmap',
    blurb: 'One page a day. Day 1 you set up the shop, day 30 you have a real business.',
    value: 27,
    icon: 'roadmap'
  }
]

export const loserPoints: string[] = [
  'No commercial license',
  'Zero bonuses included',
  'No business roadmap',
  'Expires after one project'
]

export const winnerPoints: string[] = [
  '1,000+ viral patterns, forever yours',
  'Full commercial license included',
  'Etsy SEO + pricing + branding system',
  'Instant download, one-time payment'
]

export const choices: Choice[] = [
  {
    id: 'choice-a',
    label: 'Choice A',
    title: 'You close this page.',
    outcome: 'You continue to be a "starving artist."',
    tone: 'loss',
    points: [
      { id: 'a1', text: 'You go back to Etsy and buy one pattern for $9.' },
      { id: 'a2', text: 'Then another. By next week you\u2019ve spent $27 anyway.' },
      { id: 'a3', text: 'You own three PDFs and zero business plan.' }
    ]
  },
  {
    id: 'choice-b',
    label: 'Choice B',
    title: 'You act like a CEO.',
    outcome: 'Tomorrow you\u2019re on the path to your first $1,000 month.',
    tone: 'win',
    points: [
      { id: 'b1', text: 'You spend $27 once and get the 1,000+ patterns.' },
      { id: 'b2', text: 'You get the SEO secrets, the branding, the license.' },
      { id: 'b3', text: 'You set up your shop tonight.' }
    ]
  }
]

export const faqItems: FaqItem[] = [
  {
    id: 'faq-price',
    question: 'Why so cheap?',
    answer:
      'Because we want to build the largest community of makers in the US. Once you see the quality, you\u2019ll be a customer for life.'
  },
  {
    id: 'faq-legal',
    question: 'Is this legal?',
    answer:
      'Yes. The Commercial License is included. You make it, you sell it, you keep the money.'
  },
  {
    id: 'faq-bored',
    question: 'Will I get bored?',
    answer: 'With 1,000 patterns? You\u2019d have to live 3 lives to finish them all.'
  }
]
